// import { useCustomAuthStore } from "@/store/stores/customAuthStores.js";
import { useAuthAppStore } from "@/store/stores/authStore";
import { permissionEnum } from "@/constants/permissionEnum";
import { PermissionService } from "../permissionService/permissionService";

export class PurchaseRequestService {
  async getAllEntitiesPaged({
    purchaseRequestServiceClient,
    searchQuery,
    params,
    status,
    assingStatus,
    departmentQuery,
    priority,
    assignedUser,
    terminal
  }) {
    var resp = this.getFiltersByUserPermissions(
      params,
      status,
      assingStatus,
      departmentQuery,
      priority,
      assignedUser,
      terminal
    );

    if (!resp.stopped) {
      var response = await purchaseRequestServiceClient.get({
        route: "/purchase-request/get-all-entities-paged",
        params: params,
        headers: {
          "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
          Authorization: `Bearer ${useAuthAppStore().token}`,
        },
        successCallback: function (resp) {
          // if (resp.data.length > 0)
          //     _selectedJob.unitsOnTruck = resp.data;
        },
        errorCallback: function (resp) { },
      });

      return response;
    } else {
      return null;
    }
  }

  async deletePurchaseRequestItemDeleteEntity({
    purchaseRequestServiceClient,
    params,
  }) {
    var response = await purchaseRequestServiceClient.delete({
      route: "/purchase-request-item/delete-entity",
      params: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) { },
    });

    return response;
  }

  async deletePurchaseRequestItemDeleteEntities({
    purchaseRequestServiceClient,
    params,
  }) {
    var response = await purchaseRequestServiceClient.delete({
      route: "/purchase-request-item/delete-entities",
      params: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) { },
    });

    return response;
  }

  getFiltersByUserPermissions(
    params,
    status,
    assingStatus,
    departmentQuery,
    priority,
    assignedUser,
    terminal
  ) {
    var stopped = false;

    // Mevcut filtre varsa çözümle
    let currentFilter = JSON.parse(params.filter || "[]");
    if (!Array.isArray(currentFilter)) {
      currentFilter = []; // Eğer bir dizi değilse boş bir dizi başlatıyoruz
    }

    // readALL yetkisine göre aksiyon
    const hasPRReadAllPermission = this.hasPRReadAllPermission();
    if (!hasPRReadAllPermission) {
      const userName = useAuthAppStore().getParsedToken?.userName;

      if (currentFilter.length > 0) {
        currentFilter.push("and", ["UserName", "=", userName]);
      } else {
        currentFilter.push(["UserName", "=", userName]);
      }
    }

    // ALL yetkisi varsa başka bir şeye bakmadan hepsini göster
    const hasPRStatusAllPermission = this.hasPRStatusAllPermission();
    if (!hasPRStatusAllPermission) {
      // All yetkisi yoksa diğerlerinden hangi yetkileri var onlar çekilir ve filtreye eklenir.
      const prefix = "PR_Status";

      // All yetkisi hariç diğer yetkileri çekiyoruz
      const filteredUserPerms = useAuthAppStore().getParsedToken?.perms?.filter(
        (permission) =>
          permission.startsWith(prefix) && !permission.includes("All")
      );

      if (filteredUserPerms.length > 0) {
        // Dinamik filtre oluşturma
        const dynamicFilter = filteredUserPerms.reduce(
          (acc, permission, index) => {
            const condition = ["Status", "=", permission.split(".")[1]]; // Tek tek filtreyi oluştur
            if (index === 0) {
              // İlk eleman için sadece koşulu ekle
              return condition;
            } else {
              // Diğer elemanlar için "or" ile birleştir
              return [acc, "or", condition];
            }
          },
          []
        );

        // Mevcut filtreye dinamik filtreyi ekle
        if (currentFilter.length > 0) {
          currentFilter.push("and", [dynamicFilter]);
        } else {
          currentFilter = [dynamicFilter];
        }
      } else {
        // Eğer filtre yoksa varsayılan bir filtre ekle
        if (currentFilter.length > 0) {
          currentFilter.push("and", ["Status", "=", ""]);
        } else {
          currentFilter.push(["Status", "=", ""]);
        }

        //All yoktu başka bir filtre de yok
        return {
          stopped: true,
          params: null,
        };
      }
    }

    // Status ve searchQuery kontrolü
    if (
      status ||
      assingStatus ||
      params.searchQuery ||
      departmentQuery ||
      priority ||
      assignedUser ||
      terminal
    ) {
      if (status) {
        if (currentFilter.length > 0) {
          currentFilter.push("and", ["Status", "Contains", status]);
        } else {
          currentFilter.push(["Status", "Contains", status]);
        }
      }

      if (assingStatus) {
        if (assingStatus === "AssignedToMe") {
          const userName = useAuthAppStore().getParsedToken?.userName;
          if (currentFilter.length > 0) {
            currentFilter.push("and", ["AssignedUser", "=", userName]);
          } else {
            currentFilter.push(["AssignedUser", "=", userName]);
          }
        } else if (assingStatus === "NotAssigned") {
          const userName = useAuthAppStore().getParsedToken?.userName;
          if (currentFilter.length > 0) {
            currentFilter.push("and", ["AssignedUser", "=", null]);
          } else {
            currentFilter.push(["AssignedUser", "=", null]);
          }
        }
      }

      // if (params.searchQuery) {
      //   if (currentFilter.length > 0) {
      //     currentFilter.push("and", [
      //       ["Number", "contains", params.searchQuery],
      //     ]);
      //   } else {
      //     currentFilter.push([["Number", "contains", params.searchQuery]]);
      //   }
      // }

      if (departmentQuery) {
        if (currentFilter.length > 0) {
          currentFilter.push("and", [
            "Department",
            "contains",
            departmentQuery,
          ]);
        } else {
          currentFilter.push(["Department", "contains", departmentQuery]);
        }
      }

      if (priority) {
        if (currentFilter.length > 0) {
          currentFilter.push("and", ["UsagePurpose", "contains", priority]);
        } else {
          currentFilter.push(["UsagePurpose", "contains", priority]);
        }
      }

      if (assignedUser) {
        if (currentFilter.length > 0) {
          currentFilter.push("and", ["AssignedUser", "contains", assignedUser]);
        } else {
          currentFilter.push(["AssignedUser", "contains", assignedUser]);
        }
      }

      console.log("terminal", terminal);

      if (terminal && terminal.length > 0) {
        let orFilter = [];

        terminal.forEach((t, index) => {
          if (index > 0) {
            orFilter.push("or");
          }
          orFilter.push(["ComplexCode", "contains", t]);
        });

        if (currentFilter.length > 0) {
          currentFilter.push("and", orFilter);
        } else {
          currentFilter.push(orFilter);
        }
      }

      // searchQuery araması backend tarafında SearchQuery parametresi ile yapılıyor.
      // Backend, Number, Creator ve item Code/Name alanlarında parametreli sorgu ile arar.

      if (params.dateFrom) {
        const dateFilter = ["Created", ">=", params.dateFrom];
        currentFilter.length > 0 ? currentFilter.push("and", dateFilter) : currentFilter.push(dateFilter);
      }
      if (params.dateTo) {
        const dateFilter = ["Created", "<=", params.dateTo + "T23:59:59"];
        currentFilter.length > 0 ? currentFilter.push("and", dateFilter) : currentFilter.push(dateFilter);
      }
    }

    params.filter = JSON.stringify(currentFilter);
    return {
      stopped: false,
      params: params,
    };
  }

  hasPRReadAllPermission() {
    var userPerms = useAuthAppStore().getParsedToken?.perms;
    let permissionService = new PermissionService();

    if (!Array.isArray(userPerms)) {
      return false;
    }

    return permissionService.checkPermissionsForOperations(
      permissionEnum.PurchaseRequestReadAll
    );
  }
  hasPRStatusAllPermission() {
    var userPerms = useAuthAppStore().getParsedToken?.perms;
    let permissionService = new PermissionService();

    if (!Array.isArray(userPerms)) {
      return false;
    }

    return permissionService.checkPermissionsForOperations(
      permissionEnum.PRStatusAll
    );
  }

  async getEntityByPkey({ purchaseRequestServiceClient, params }) {
    var response = await purchaseRequestServiceClient.get({
      route: "/purchase-request/get-entity-by-pkey",
      params: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore()?.getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) { },
    });

    return response;
  }

  // bu method onay maili giden kullanıcıların onaylamasını veya iptal etmesini sağlar
  async setStageStatus({ purchaseRequestServiceClient, params }) {
    var response = await purchaseRequestServiceClient.post({
      route: "/purchase-request/set-stage-status",
      data: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore()?.getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) { },
    });

    return response;
  }

  // bu method onay maili giden kullanıcıların onaylamasını veya iptal etmesini sağlar
  async setDownloadAllFiles({ purchaseRequestServiceClient, params }) {
    var response = await purchaseRequestServiceClient.post({
      route: "/purchase-request/download-all-files",
      data: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore()?.getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) { },
    });

    return response;
  }

  // bu method onay maili giden kullanıcıların onaylamasını veya iptal etmesini sağlar
  async getStatsByApprover({ purchaseRequestServiceClient }) {
    var response = await purchaseRequestServiceClient.get({
      route: "/purchase-request/stats-by-approver",
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore()?.getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) { },
    });

    return response;
  }

  //confirm processini başlatır ve onaylama sürecindeki ilk kişiye onay maili gider.
  async sendToApprovers({ purchaseRequestServiceClient, params }) {
    let response;
    try {
      response = await purchaseRequestServiceClient.post({
        route: "/purchase-request/send-to-approvers",
        data: params,
        headers: {
          "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
          Authorization: `Bearer ${useAuthAppStore().token}`,
        },
      });
    }
    catch (error) {
      console.error("error", error);
      response = error.response ?? error;
    }
    return response;
  }

  // Mevcut bekleyen onaycıya onay mailini yeniden gönderir. Matris/state değişmez.
  async resendApprovalEmail({ purchaseRequestServiceClient, params }) {
    let response;
    try {
      response = await purchaseRequestServiceClient.post({
        route: "/purchase-request/resend-approval-email",
        data: params,
        headers: {
          "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
          Authorization: `Bearer ${useAuthAppStore().token}`,
        },
      });
    }
    catch (error) {
      console.error("error", error);
      response = error.response ?? error;
    }
    return response;
  }

  async setSendToCancel({ purchaseRequestServiceClient, params }) {
    var response = await purchaseRequestServiceClient.put({
      route: "purchase-request/update-status",
      params: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) { },
      errorCallback: function (errorResp) { },
    });

    return response;
  }

  hasReadAllPermission() {
    var userPerms = useAuthAppStore().getParsedToken?.perms;
    let permissionService = new PermissionService();

    if (!Array.isArray(userPerms)) {
      console.error("Kullanıcı izinleri bir dizi değil:", userPerms);
      return false;
    }

    return permissionService.checkPermissionsForOperations(
      permissionEnum.PurchaseRequestReadAll
    );
  }

  async updateAssignedUser({ purchaseRequestServiceClient, params }) {
    var response = await purchaseRequestServiceClient.put({
      route: "purchase-request/update-assigned-user",
      params: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) { },
      errorCallback: function (errorResp) { },
    });

    return response;
  }

  async findPurchaseRequestByApprover({
    purchaseRequestServiceClient,
    searchQuery,
    params,
    assingStatus,
    priority,
    assignedUser,
    departmentQuery,
    terminal,
  }) {
    var resp = this.getFiltersByUserPermissions(
      params,
      status,
      assingStatus,
      departmentQuery,
      priority,
      assignedUser,
      terminal
    );

    var response = await purchaseRequestServiceClient.get({
      route: "/purchase-request/find-by-approver",
      params: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) { },
    });

    return response;
  }

  async setExport({ client, params }) {
    var response = await client.get({
      route: "/purchase-request/download-entities",
      params: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        "Content-Type": "application/json",
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
    });
    return response;
  }
}
